if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name="id"]').disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      getCartComponent() {
        return (
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        );
      }

      isFootiboxProduct() {
        /*
         * On regarde l'URL du product-info lorsque Dawn
         * nous la fournit.
         */
        const productInfo =
          this.closest('product-info');

        if (
          productInfo &&
          productInfo.dataset.url
        ) {
          return productInfo.dataset.url.includes(
            '/products/la-footibox'
          );
        }

        /*
         * Sécurité pour la page produit principale.
         */
        return window.location.pathname.includes(
          '/products/la-footibox'
        );
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading__spinner'
          );

        if (spinner) {
          spinner.classList.remove(
            'hidden'
          );
        }

        try {
          /*
           * On récupère le cart drawer au moment du clic.
           */
          this.cart =
            this.getCartComponent();

          if (this.isFootiboxProduct()) {
            await this.addFootiboxWithGift();
            return;
          }

          await this.addStandardProduct();

        } catch (error) {
          console.error(
            'Erreur lors de l’ajout au panier :',
            error
          );

          this.handleErrorMessage(
            error.message ||
              "Une erreur est survenue lors de l’ajout au panier."
          );

        } finally {
          this.submitButton.classList.remove(
            'loading'
          );

          if (spinner) {
            spinner.classList.add(
              'hidden'
            );
          }

          this.submitButton.removeAttribute(
            'aria-disabled'
          );
        }
      }

      async addFootiboxWithGift() {
        const formData =
          new FormData(this.form);

        const selectedVariantId =
          Number(
            formData.get('id')
          );

        const quantity =
          Math.max(
            1,
            Number(
              formData.get(
                'quantity'
              ) || 1
            )
          );

        const sellingPlanId =
          formData.get(
            'selling_plan'
          );

        if (!selectedVariantId) {
          throw new Error(
            'La taille sélectionnée n’a pas pu être identifiée.'
          );
        }

        /*
         * Propriétés personnalisées de la Footibox.
         */
        const properties = {};

        formData.forEach(
          (value, key) => {
            const propertyMatch =
              key.match(
                /^properties\[(.+)\]$/
              );

            if (
              propertyMatch &&
              value !== ''
            ) {
              properties[
                propertyMatch[1]
              ] = value;
            }
          }
        );

        const footiboxItem = {
          id: selectedVariantId,
          quantity: quantity
        };

        if (
          Object.keys(properties).length > 0
        ) {
          footiboxItem.properties =
            properties;
        }

        /*
         * L'abonnement Seal reste uniquement
         * sur la Footibox.
         */
        if (sellingPlanId) {
          footiboxItem.selling_plan =
            Number(sellingPlanId);
        }

        /*
         * Poster offert.
         */
        const posterItem = {
          id: 54305661485389,
          quantity: quantity,
          properties: {
            '_Cadeau Footibox':
              'Poster Le Numéro 7'
          }
        };

        /*
         * Footibox + poster dans une seule requête.
         *
         * On demande également à Shopify les sections
         * nécessaires au petit panier.
         */
        const requestBody = {
          items: [
            footiboxItem,
            posterItem
          ],
          sections: [
            'cart-drawer',
            'cart-icon-bubble'
          ],
          sections_url:
            window.location.pathname
        };

        if (this.cart) {
          this.cart.setActiveElement(
            document.activeElement
          );
        }

        const response = await fetch(
          window.routes.cart_add_url,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },
            body:
              JSON.stringify(
                requestBody
              )
          }
        );

        const responseData =
          await response.json();

        if (
          !response.ok ||
          responseData.status
        ) {
          throw new Error(
            responseData.description ||
            responseData.message ||
            "Impossible d’ajouter la Footibox et son poster au panier."
          );
        }

        this.error = false;

        /*
         * On recherche à nouveau le cart drawer
         * une fois l'ajout terminé.
         */
        this.cart =
          this.getCartComponent();

        if (this.cart) {
          /*
           * On tente d'abord de rafraîchir le contenu
           * du petit panier avec les sections renvoyées
           * par Shopify.
           */
          if (responseData.sections) {
            try {
              this.cart.renderContents(
                responseData
              );
            } catch (error) {
              console.error(
                'Erreur actualisation du petit panier :',
                error
              );
            }
          }

          /*
           * OUVERTURE EXPLICITE DU PETIT PANIER.
           *
           * Même si renderContents ne déclenche pas
           * correctement l'ouverture dans ce contexte,
           * on appelle open() nous-mêmes.
           */
          window.setTimeout(
            () => {
              try {
                this.cart.open(
                  this.submitButton
                );
              } catch (error) {
                console.error(
                  'Erreur ouverture du petit panier :',
                  error
                );
              }
            },
            150
          );

          return;
        }

        /*
         * Fallback uniquement si aucun cart drawer
         * n'existe réellement sur la page.
         */
        window.location.href =
          window.routes.cart_url;
      }

      async addStandardProduct() {
        const config =
          fetchConfig(
            'javascript'
          );

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];

        const formData =
          new FormData(
            this.form
          );

        this.cart =
          this.getCartComponent();

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map(
                (section) =>
                  section.id
              )
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body =
          formData;

        const response =
          await fetch(
            `${window.routes.cart_add_url}`,
            config
          );

        const responseData =
          await response.json();

        if (
          responseData.status
        ) {
          publish(
            PUB_SUB_EVENTS.cartError,
            {
              source:
                'product-form',

              productVariantId:
                formData.get('id'),

              errors:
                responseData.errors ||
                responseData.description,

              message:
                responseData.message
            }
          );

          this.handleErrorMessage(
            responseData.description
          );

          const soldOutMessage =
            this.submitButton.querySelector(
              '.sold-out-message'
            );

          if (soldOutMessage) {
            this.submitButton.setAttribute(
              'aria-disabled',
              true
            );

            const buttonText =
              this.submitButton.querySelector(
                'span'
              );

            if (buttonText) {
              buttonText.classList.add(
                'hidden'
              );
            }

            soldOutMessage.classList.remove(
              'hidden'
            );
          }

          this.error = true;
          return;
        }

        this.cart =
          this.getCartComponent();

        if (!this.cart) {
          window.location.href =
            window.routes.cart_url;

          return;
        }

        if (!this.error) {
          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source:
                'product-form',

              productVariantId:
                formData.get('id'),

              cartData:
                responseData
            }
          );
        }

        this.error = false;

        const quickAddModal =
          this.closest(
            'quick-add-modal'
          );

        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(
                  responseData
                );
              });
            },
            { once: true }
          );

          quickAddModal.hide(true);

        } else {
          this.cart.renderContents(
            responseData
          );
        }
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}